import { isEmpty } from 'lodash';

var ConstantsHelper = require('../constants').ConstantsHelper;
var ActionType = require('../constants/actionType');

exports.GetActionError = function (actionType, error) {
  var errorMessage = '';

  if (!error || !error.errorObject) {
    return ConstantsHelper.Error.DEFAULT_ERROR;
  }

  switch (actionType) {
    case ActionType.PROFILE_UPDATE_ACCOUNT_FAILURE:
    case ActionType.USERS_UPDATE_USER_FAILURE:
      if (isEmpty(error.modelState)) {
        return error.message;
      }

      _.forOwn(error.errorObject.modelState, function (val, key) {
        errorMessage = key in ConstantsHelper.Error[actionType] ? ConstantsHelper.Error[actionType][key] : val;
      });
      break;

    case ActionType.AUTH_LOGIN_FAILURE:
    case ActionType.AUTH_LOGIN_SSO_FAILURE:
    case ActionType.AUTH_LOGIN_ACT_AS_FAILURE:
      errorMessage = error.errorObject.error_description;
      break;

    case ActionType.LEARNERS_UPDATE_LEARNER_FAILURE:
      if (isEmpty(error.modelState)) {
        return error.message;
      }

      var errorValues = Object.values(error.modelState) || [];
      errorMessage = errorValues.toString();
      break;

    default:
      break;
  }

  return errorMessage ? errorMessage : ConstantsHelper.Error.DEFAULT_ERROR;
};

export function handleLazyLoadError() {
  window.location.reload();
}
